/* src/app/shared/components/modal/modal.component.scss */
.modal-content {
  z-index: 1010;
  text-align: left;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  z-index: 1010;
  margin: 0px auto;
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
#okCancelModal .modal-footer {
  display: inline-block;
  text-align: center;
}
#okCancelModal .modal-footer .ahe-ui-checkbox {
  font-size: 13px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
::ng-deep .modal-dialog .modal-content .modal-header-new .close {
  height: 35px;
  opacity: 1;
  outline: 0;
  width: 45px;
  margin-top: -12px;
}
/*# sourceMappingURL=modal.component.css.map */
